module.exports = __webpack_public_path__ + "static/media/bowen-8.be66ff3a.jpg";